import DirectionTypeIcon from './TransactionDirectionTypeIcon';

export default DirectionTypeIcon;
